/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_In_ProgressInputs */

const en_dashboard_stat_in_progress = /** @type {(inputs: Dashboard_Stat_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const pt_br2_dashboard_stat_in_progress = /** @type {(inputs: Dashboard_Stat_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em Andamento`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Dashboard_Stat_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_in_progress = /** @type {((inputs?: Dashboard_Stat_In_ProgressInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_In_ProgressInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_stat_in_progress(inputs)
	return pt_br2_dashboard_stat_in_progress(inputs)
});